import React, { useState } from 'react';

import Button, { BUTTON_SIZES, BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import Modal from 'buyside/components/presentation/Modal/modal';

import styles from './userGeneratedLinkStyles.scss';

const UserGeneratedLink: React.FC<{
  children: JSX.Element | JSX.Element[] | string;
  href: string;
  onClick?: () => void;
}> = ({ children, href, onClick }): React.ReactElement => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  let url: URL;

  try {
    url = new URL(href);
  } catch {
    // If an error is thrown it's because a relative href was provided (such as '/privacy') - DAC 2023/03/15
    url = new URL(href, window.location.href);
  }

  if (url.hostname === location.hostname) {
    return (
      <a target="_blank" href={url.href}>
        {children}
      </a>
    );
  }

  return (
    <>
      <a
        className={styles.externalLink}
        href={url.href}
        onClick={(e): void => {
          e.preventDefault();
          setIsModalOpen(true);
        }}
        target="_blank"
      >
        {children}
      </a>
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title="External Link">
        <div className={styles.externalLinkModal}>
          <p>
            Following this link opens a new browser tab to <strong>{url.hostname}</strong>, which is
            a website outside of SumZero.
          </p>
          <Button
            onClick={(): void => {
              if (onClick) onClick();
              setIsModalOpen(false);
            }}
            size={BUTTON_SIZES.MEDIUM}
            target="_blank"
            text="Confirm"
            type={BUTTON_TYPES.PRIMARY}
            url={url.href}
          />
          <Button
            onClick={() => setIsModalOpen(false)}
            size={BUTTON_SIZES.MEDIUM}
            text="Cancel"
            type={BUTTON_TYPES.DANGER}
          />
        </div>
      </Modal>
    </>
  );
};

export default UserGeneratedLink;
